import React, { useState, memo, useEffect, useMemo, useContext } from "react";
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  UncontrolledDropdown,
  DropdownToggle ,
  DropdownMenu ,
  DropdownItem 
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

// Pages
import Breadcrumbs from "../../components/common/Breadcrumb";
import {
    handleAddEditUserApi,
    getAllUsersDetailsApi,
    handleChangeUserStatusApi,
    fetchSingleUserDetailsApi,
    getAllRoles
} from "../../api/userApi";

import { AuthContext } from "../../contexts/AuthContext";
import { useAppSettings } from '../../contexts/AppSettingsContext';
import PaginationComponent from "../../components/common/Pagination";
function Users() {
  const { appSettings } = useAppSettings();
  const itemsPerPage = process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE;  
  const appName = appSettings?.title || process.env.REACT_APP_APP_NAME;
  const [userModal, setUserModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [roles, setRoles] =  useState([]);
  const [popUpMode, setPopUpMode] = useState("")
  const [singleUserDetails, setSingleUserDetails] = useState({});
  const { authToken } = useContext(AuthContext);
  const [selectedItem, setSelectedItem] = useState({});
  const [defaultRoleId , setDefaultRoleId] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);


console.log("roles--------->", roles);

  const rolesDetails  =  useMemo(()=>{
    const formattedData  =  roles.filter((item)=>item.id !== null)
      return formattedData
  },[roles])
  // Set token
  useEffect(() => {
    if (authToken) {

      fetchAllRoles()
      
    }
  }, [authToken]);
useEffect(()=>{
  if(authToken){

    fetchAllUsers(defaultRoleId);
  }
},[authToken, currentPage])
  
  useEffect(()=>{
    if(rolesDetails.length==0){
      return
    }
    setSelectedItem({
      "id": null,
      "name": "All Users"
  })
  },[rolesDetails])

  // Function handle open & close modal
  const toggle = () => {
    setUserModal(!userModal);
    if (!userModal) {
      // # Reset form to initial values when modal is closed
      userForm.resetForm();
      setErrorMessage("");
      setSuccessMessage("");
      setSingleUserDetails({});
      setPopUpMode("");
    }
  };


  // #Handle customer form
  const userForm = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: singleUserDetails?.name || "",
      image:  singleUserDetails?.image || null,
      email: singleUserDetails?.email ||  "",
      user_name: singleUserDetails?.user_name ||  "",
      password:  "",
      role : singleUserDetails?.role ||  "",
      contact_no : singleUserDetails?.contact_no || "",
      emergency_contact_no : singleUserDetails?.emergency_contact_no || "",
      address : singleUserDetails?.address || "",
      id_proof: singleUserDetails?.id_proof || null
    },
    validationSchema: Yup.object({
      user_name: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
      password: Yup.string()
        .matches(/^\S+$/, "Spaces are not allowed")
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[^a-zA-Z0-9]/, "Password must contain at least one special character"),
      contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
      emergency_contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {

      if(values.contact_no.trim() == values.emergency_contact_no.trim()){
        setErrorMessage("Emergency contact number cannot be the same as the contact number.");
        return
      }

      values.isEdit  =  false

      if(popUpMode == 'EDIT'){
          const userId = singleUserDetails?.id
          values.isEdit  = true
          values.id   = userId
      }
      console.log("submitted values ->", values);
      handleAddOrEditUser(values);
    },
  });

  // Function handle user add or edit functionality
  async function handleAddOrEditUser(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditUserApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            let roleId  = false;
            if(Object.keys(selectedItem).length !==0){
                roleId =  selectedItem.id
            }
            fetchAllUsers(roleId);
            setDefaultRoleId(roleId)
            setUserModal(false);
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  async function fetchAllRoles() {
    try {
      
      
      let response = await getAllRoles(authToken);
      if (response?.code == 200) {
        let  copyArr  =  [...response?.data]
        copyArr.unshift({id: null, name : 'All Users'})
        setRoles(copyArr || []);
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }

  // Function for fetch all users
  async function fetchAllUsers(roleId ) {
    try {
      console.log("roleId------------------>", roleId);
      
      let response = await getAllUsersDetailsApi(authToken , roleId, currentPage, itemsPerPage);
      const responseData  =  response?.data
      if (response?.code == 200) {
        setUsers(responseData.users || []);
        setTotalPages(Math.ceil((responseData.totalCount || 1) / itemsPerPage));
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }
  // Function for change user status 
  const handleChangeUserStatus = async(userId) =>{
    try{

      let response = await handleChangeUserStatusApi(userId, authToken);
      if (response?.code == 200) {
            const updatedUsers = users?.map((item)=>
              userId == item.id ?  {...item,status : item.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'} : item)
            setUsers(updatedUsers)
      } 
    }catch(error){
        console.log("error",error);
    }
  }

  // Function for fetch single  product details based on the  product id 
  const fetchSingleUserDetails= async(userId) =>{
    try{
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchSingleUserDetailsApi(authToken, userId);
      if (response?.code == 200) {
        toggle();
        setSingleUserDetails(response?.data || []);
      }
      setPopUpMode("EDIT");
    
    }catch(err){
      console.log("err",err.message);
    }
  }
  const handleProductChange = (data) => {
    try{
      console.log("data", data);
      
      setCurrentPage(1)
      fetchAllUsers(data.id)
      setDefaultRoleId(data.id)
    }catch(err){
      console.log("err", err.message);
    }
    setSelectedItem(data);
  };

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={appName} breadcrumbItem="Users" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader tag="h5" className="p-1  d-flex justify-content-between">
                <Button color="success" onClick={toggle}>
                  Add User
                </Button>
                <UncontrolledDropdown className="me-2" direction="down">
                  <DropdownToggle caret style={{background : '#005affd9', marginBottom : '9px'}} >
                    {selectedItem?.name}
                  </DropdownToggle>
                  <DropdownMenu>
                  {/* style={{selectedItem == 'Products' ? '' : ''}}  */}
                  {
                    roles?.map((item, index)=>(
                      <div key={index}>
                       <DropdownItem   
                            style={{
                              backgroundColor: selectedItem.id === item.id ? 'antiquewhite' : ''
                            }} 
                            onClick={() => handleProductChange(item)}>
                            {item.name}
                        </DropdownItem>
                        <DropdownItem divider />
                      </div>
                    ))
                  }
                    
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader>
              <MemoisedProductOpenPopUp
                userModal={userModal}
                toggle={toggle}
                userForm={userForm}
                errorMessage={errorMessage}
                successMessage={successMessage}
                popUpMode={popUpMode}
                rolesDetails={rolesDetails}
              />
              <CardBody>
                <Table striped>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>User Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Contact Number</th>
                      <th>Created at</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td >
                           <img className="listItemImage" src={item.image} alt={`${item.name}  image `}/>
                        </td>
                        <td>{item.user_name}</td>
                        <td>{item.email}</td>
                        <td>{item.role}</td>
                        <td>{item.contact_no}</td>
                        <td>{item.created_at}</td>
                        <td>
                          <Button  color={`${item.status == 'ACTIVE' ? 'success' : 'danger'}`} type="button" onClick={()=>{handleChangeUserStatus(item.id)}}>
                            {item.status}
                          </Button>
                        </td>
                        
                        <td>
                          <Button  color={`success`} type="button" onClick={()=>{fetchSingleUserDetails(item.id)}}>
                            Edit
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
              <div  className=" d-flex justify-content-end">
                <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Users;

const OpenPopUp = ({
  userModal,
  toggle,
  userForm,
  errorMessage,
  successMessage,
  popUpMode,
  rolesDetails
}) => {
  return (
    <div>
      <Modal size="xl" isOpen={userModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{ popUpMode !== 'EDIT' ? 'Add User' : 'Edit User'}</ModalHeader>
        <Form onSubmit={userForm.handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="user_name">Name:</Label>
                  <Input
                    type="text"
                    value={userForm.values.name}
                    required
                    onChange={userForm.handleChange}
                    id="user_name"
                    name="name"
                  />
                </FormGroup>
              </Col>

              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="user_image">Image:</Label>
                  {userForm.values?.image && (
                    <img
                      src={typeof userForm.values?.image == 'string' ? userForm.values?.image :  URL.createObjectURL(userForm.values?.image)}
                      alt="Image Preview"
                      className="productImagePreview"
                    />
                  )}
                  <Input
                    type="file"
                    id="user_image"
                    required={typeof userForm.values?.image !== 'string' }
                    onChange={(event) => {
                      const file = event.currentTarget.files[0];
                      if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
                        userForm.setFieldValue("image", file);
                      } else {
                        event.target.value = null;
                        if(!(userForm.values?.image instanceof File)){
                          userForm.setFieldError("image", "Only JPG or PNG files are allowed.");
                        }
                        
                      }
                    }}
                    name="image"
                  />
                     {userForm.errors.image && (
                      <div className="invalidError d-flex justify-content-center">{userForm.errors.image}</div>
                    )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="user_email">Email:</Label>
                  <Input
                    type="email"
                    id="user_email"
                    value={userForm.values.email}
                    required
                    onChange={userForm.handleChange}
                    name="email"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="user_name">User Name:</Label>
                  <Input
                    type="text"
                    id="user_name"
                    value={userForm.values.user_name}
                    required
                    onChange={userForm.handleChange}
                    name="user_name"
                  />
                </FormGroup>
                {userForm.errors.user_name &&
                  userForm.errors.user_name ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {userForm.errors.user_name}
                    </div>
                  ) : null}
              </Col>
              {popUpMode !== 'EDIT' && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="user_password">
                   password
                  </Label>
                  <Input
                    type="text  "
                    id="user_password"
                    value={userForm.values.password}
                    required
                    onChange={userForm.handleChange}
                    name="password"
                  />
                </FormGroup>
                {userForm.errors.password &&
                  userForm.errors.password ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {userForm.errors.password}
                    </div>
                  ) : null}
              </Col>}
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="role">Role:</Label>
                  <select
                        className="selectInput"
                        id="role"
                        name="role"
                        required
                        value={userForm.values.role}
                        onChange={userForm.handleChange}
                      >
                        <option value={""}>Select role</option>
                        {rolesDetails?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="customer_no">Contact Number:</Label>
                  <Input
                    type="text"
                    id="customer_no"
                    value={userForm.values.contact_no}
                    required
                    onChange={userForm.handleChange}
                    name="contact_no"
                  />
                </FormGroup>
                {userForm.errors.contact_no &&
                  userForm.errors.contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {userForm.errors.contact_no}
                    </div>
                  ) : null}
              </Col>
              <Col md={3}>
                <FormGroup>
                  {userForm.values?.id_proof && popUpMode == 'EDIT' && <>
                  <br/>
                  <br/>
                  </>}

                  <Label htmlFor="emergency_contact_no">
                    Emergency Contact Number:
                  </Label>
                  <Input
                    type="text  "
                    id="emergency_contact_no"
                    value={userForm.values.emergency_contact_no}
                    required
                    onChange={userForm.handleChange}
                    name="emergency_contact_no"
                  />
                </FormGroup>
                {userForm.errors.emergency_contact_no &&
                  userForm.errors.emergency_contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {userForm.errors.emergency_contact_no}
                    </div>
                  ) : null}
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="customer_id_proof ">Id Proof:</Label>
                  {userForm.values?.id_proof && (
                    <img
                      src={typeof userForm.values?.id_proof == 'string' ? userForm.values?.id_proof :  URL.createObjectURL(userForm.values?.id_proof)}
                      alt="id proof Preview"
                      className="productImagePreview"
                    />
                  )}
          
                  <Input
                    type="file"
                    id="customer_id_proof"
                    required={typeof userForm.values?.id_proof !== 'string' }
                    onChange={(event) => {
                      const file = event.currentTarget.files[0];
                      // Validate the file type
                      if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
                        // If valid, set the file in the form
                        userForm.setFieldValue("id_proof", file);
                      } else {
                        // If invalid, clear the input and optionally show an error message
                        event.target.value = null;
                        if(!(userForm.values?.id_proof instanceof File)){
                          userForm.setFieldError("id_proof", "Only JPG or PNG files are allowed.");
                        }
                      }
                    }}
                    name="id_proof"
                  />
                  {userForm.errors.id_proof && (
                      <div className="invalidError d-flex justify-content-center">{userForm.errors.id_proof}</div>
                    )}
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="contact_address">Contact Address</Label>
                  <textarea
                    className="selectInput"
                    id="contact_address"
                    name="address"
                    value={userForm.values.address}
                    required
                    onChange={userForm.handleChange}
                  />
                </FormGroup>
              </Col>

            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};
const MemoisedProductOpenPopUp = memo(OpenPopUp);
